import type { FC } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, Typography } from '@mui/material'
import { formatTimestamp } from '@/common/utils'

interface DraftTimestampsProps {
  readonly createdAt: number
  readonly updatedAt: number
}

export const DraftTimestamps: FC<DraftTimestampsProps> = ({ createdAt, updatedAt }) => (
  <Box sx={containerSx}>
    <Typography component="span" sx={timestampSx}>
      Created: {formatTimestamp(createdAt)}
    </Typography>
    <Typography component="span" sx={timestampSx}>
      Updated: {formatTimestamp(updatedAt)}
    </Typography>
  </Box>
)

const containerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: 1.5,
}

const timestampSx: SxProps<Theme> = {
  fontSize: '0.6875rem',
  color: 'text.disabled',
}
